
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PageInWP } from "@/lib/singularity/wp-page-manager/types";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { replaceDocumentWithAnother } from "@/lib/wordpress/load";
import IconButton from "@/components/UI/IconButton.vue";
import Icon from "@/components/UI/Icon.vue";
import { documentStore, singularityStore } from "@/store/store";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";

@Component({
  components: {
    IconButton,
    Icon,
    Dropdown
  }
})
export default class WPPageManagerPage extends Vue {
  @Prop()
  value!: PageInWP;

  async openInCanvas() {
    singularityStore.setIsOpeningPageId(this.value.id);
    await saveToWordPressWithErrorsLoggedToUiStore();
    await replaceDocumentWithAnother(this.value.id);
    singularityStore.setIsOpeningPageId(false);
    singularityStore.setSingularityLeftPanel("page_structure");
  }

  get isOpeningPage() {
    return singularityStore.isOpeningPageId === this.value.id;
  }

  get isHomepage() {
    return this.value.title.toLowerCase().includes("home");
  }

  get active() {
    return this.value.id === documentStore.document.documentMeta.id;
  }

  get classList() {
    return {
      "is-active": this.active,
      "is-opening": this.isOpeningPage
    };
  }
}
